import { DataSource, Layout, SearchButton, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRendDocumentProfiles extends Layout {
    SearchDocProf: SearchButton;
    sourceRenditionDocumentProfiles: DataSource;
    table1: Table;
    textboxDocpSeq: Textbox;
}
